import BaseToolMixin from '@/app/shared/mixins/BaseToolMixin';
import GlobalMixin from '@/app/shared/mixins/global';
import PermissionsMixin from './PermissionsMixin';

export default {
    mixins: [
        GlobalMixin,
        BaseToolMixin,
        PermissionsMixin,
    ],
    props: {
    },
    data() {
        return {
            idPanel: null,
        }
    },
    computed: {
    },
    methods: {
    }
}